import { useEffect, useRef, useState } from "react";
import { useApi } from "@services/useApi";
import { AssessmentHistory } from "@store/generalTypes";

// Remote attempts can change while the portal stays open on another device.
export const useAssessmentHistory = (
    locationId?: number,
    examineeId?: number
): { history: AssessmentHistory[]; error: boolean } => {
    const { getAssessmentHistoryByExaminee } = useApi();
    const fetchHistory = useRef(getAssessmentHistoryByExaminee);
    fetchHistory.current = getAssessmentHistoryByExaminee;
    const [history, setHistory] = useState<AssessmentHistory[]>([]);
    const [error, setError] = useState(false);

    useEffect(() => {
        let active = true;
        let request = 0;
        setHistory([]);
        setError(false);
        if (!locationId || !examineeId) return;

        const refresh = async (): Promise<void> => {
            const current = ++request;
            try {
                const rows = await fetchHistory.current(locationId, examineeId);
                if (active && current === request) {
                    setHistory(rows);
                    setError(false);
                }
            } catch {
                if (active && current === request) {
                    setHistory([]);
                    setError(true);
                }
            }
        };
        const onFocus = (): void => {
            void refresh();
        };
        void refresh();
        window.addEventListener("focus", onFocus);
        return () => {
            active = false;
            window.removeEventListener("focus", onFocus);
        };
    }, [locationId, examineeId]);

    return { history, error };
};
